@if (loading) {
  <app-loader />
}

@if (!loading) {
  <div class="md-content rd-3 position-relative p-0">
    <i class="material-icons md-close" (click)="close()">close</i>
    @if (form) {
      <form [formGroup]="form" (ngSubmit)="save()" [class.disabled]="readOnly">
        <!-- HEADER -->
        <div class="md-header bg-light d-flex justify-content-between align-items-center p-4">
          <div>
            @if (!event) {
              <h3>{{ 'SHARED.createBookingModal.newBooking' | translate }}</h3>
            }
            @if (event && !previewMode && !readOnly) {
              <h3>{{ 'SHARED.createBookingModal.editBooking' | translate }}</h3>
            }
            @if (event && (previewMode || readOnly)) {
              <h3>{{ 'SHARED.createBookingModal.booking' | translate }}</h3>
            }
            <!--<h3 *ngIf="!event" class="sm-title">{{day | dateFix | date:'longDate'}}</h3>-->
            @if (!event && currentMerchant?.stores?.length > 1) {
              <p>{{ store?.name }}</p>
            }
            @if (event) {
              <p class="">
                {{ 'SHARED.createBookingModal.created' | translate }} {{ this.event?.createdAt | date: dateTimeFormatShort }} •
                {{ getBookingSourceCopy() }}
              </p>
            }
          </div>
        </div>
        <!-- NEW FORM -->
        <div class="md-body">
          <div class="row">
            <!-- COLUMN 1 - SERVICES -->
            <div class="col-lg-6 mb-4">
              <!-- <h3 class="h3">Service</h3> -->
              <!-- PAST DATE WARNING -->
              @if (!previewMode && checkPastDate()) {
                <div class="row">
                  <div class="col">
                    <app-alert msg="{{ 'SHARED.createBookingModal.pastBookingWarning' | translate }}" type="warning" />
                  </div>
                </div>
              }
              <!-- ROW - DATE  -->
              <ng-template #dateDisplay>
                <div class="d-flex">
                  <h3 class="h3 mb-0">
                    <span class="text-capitalize">{{ form.get('day')?.value | date: 'EEEE' : undefined : currentLocale }}, </span
                      >{{ form.get('day')?.value | date: 'MMMM d, y' }}
                    </h3>
                    @if (!previewMode) {
                      <i class="material-icons icon">edit</i>
                    }
                  </div>
                </ng-template>
                <div class="row">
                  <div class="col">
                    <div class="nomb">
                      @if (previewMode) {
                        <div class="service-date p-3">
                          <div *ngTemplateOutlet="dateDisplay"></div>
                        </div>
                      } @else {
                        <div class="service-date clickable">
                          <div class="text-small dummy-date mb-0 pl-4">
                            <span class="invisible">
                              <input
                                class="input-date-picker"
                                readonly="true"
                                #datepickerWeb="bsDatepicker"
                                bsDatepicker
                                (bsValueChange)="onEventDateChange($event)"
                                formControlName="day"
                                [bsConfig]="bsConfig"
                                />
                            </span>
                          </div>
                          <div class="d-flex align-items-center no-mobile" (click)="datepickerWeb.toggle()">
                            <div *ngTemplateOutlet="dateDisplay"></div>
                          </div>
                          <div class="just-mobile">
                            <div class="d-flex align-items-center" (click)="dayPickerMobile = true">
                              <div *ngTemplateOutlet="dateDisplay"></div>
                            </div>
                          </div>
                          @if (dayPickerMobile) {
                            <app-mobile-date-picker title="{{ 'SHARED.createBookingModal.date' | translate }}"
                              [bsConfig]="bsConfig"
                              [bsValue]="form.get('day')?.value"
                              (modalDismiss)="dayPickerMobile = false"
                              (bsValueChange)="onEventDateChange($event, true)"
                             />
                          }
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <!-- SERVICES -->
                @if (previewMode) {
                  <div>
                    <div class="multi-event">
                      <!-- Event and price - multi or single  -->
                      @for (e of event.multipleBookings ?? [event]; track e) {
                        <div
                          class="booking-line d-flex justify-content-between"
                          [ngStyle]="{ backgroundColor: e.service.color }"
                          >
                          <span class="multi-event-text" [class.blue]="e.id === event.id">
                            {{ e?.dateInit | dateFix | date: timeFormatShort }} ∙ {{ e?.service?.name }} ({{ e.provider?.name }})
                            @if (e.roomEquipment?.name) {
                              <span class="tw:ml-2">
                                <app-room-equipment-badge [name]="e.roomEquipment?.name" size="sm" />
                              </span>
                            }
                          </span>
                          @if (e?.service?.price) {
                            <span class="multi-event-text blue">{{
                              e?.service?.price | currency: store?.currency : 'symbol-narrow' : '1.2-2'
                            }}</span>
                          }
                        </div>
                      }
                      @if (!store.salesModuleActive && event?.multipleBookings?.length > 0 && totalPriceCents > 0 && !bookingSale()?.id) {
                        <div class="pl-1 booking-line total-line d-flex justify-content-between">
                          <span class="multi-event-text"> {{ 'GENERAL.total' | translate }} </span>
                          <span class="multi-event-text">
                            {{ totalPriceCents / 100 | currency: store?.currency : 'symbol-narrow' : '1.2-2' }}
                          </span>
                        </div>
                      }
                      @if (event?.videoCallUrl) {
                        <div class="tw:my-3 tw:w-full">
                          <app-button type="primary" size="sm" extraClass="tw:w-full" (clickEvent)="openVideoCall()">
                            <i class="material-icons icon tw:!top-0 tw:inline-flex tw:items-center tw:shrink-0">videocam</i>
                            {{ 'SHARED.createBookingModal.openVideoCall' | translate }}
                          </app-button>
                        </div>
                      }
                      <!-- PAYMENTS DATA -->
                      @if (loadingSales()) {
                        <div class="tw:mb-2">
                          <app-loader />
                        </div>
                      } @else if (showSalePaymentsCard()) {
                        <div class="tw:my-4 tw:rounded-lg tw:bg-primary-50 tw:px-4 tw:py-3">
                          <div class="tw:mb-4 tw:flex tw:items-center tw:justify-between">
                            <div>
                              <!-- <div class="tw:text-lg tw:font-semibold">{{ 'GENERAL.invoice' | translate }} {{ bookingSale().code }}</div> -->
                              <div class="tw:text-lg tw:font-semibold tw:text-primary-500">
                                {{ 'SHARED.createBookingModal.saleRecord' | translate }}
                              </div>
                              <!-- <div class="tw:text-sm tw:font-semibold tw:text-neutral-500">
                              {{ bookingSale().createdAt | date: 'short' }}
                            </div> -->
                          </div>
                          <app-sales-status [sale]="bookingSale()" />
                        </div>
                        <!-- show payments for non sales module -->
                        @if (!store.salesModuleActive && bookingSale()?.salePayments?.length) {
                          <div class="tw:text-sm">
                            @for (payment of bookingSale()?.salePayments; let i = $index; track payment.id) {
                              <div
                                class="tw:border-t tw:py-3 tw:border-primary-100 tw:text-success-800 tw:flex tw:items-center tw:justify-between"
                                >
                                <div class="tw:font-semibold">
                                  {{ payment.paymentMethod | paymentMethod: payment.isOnlinePayment }} ({{
                                  payment.paidAt | date: 'short'
                                  }})
                                </div>
                                <div class="tw:font-semibold">+{{ payment.amount | merchantCurrency }}</div>
                              </div>
                            }
                            @if (bookingSale()?.tip > 0) {
                              <div
                                class="tw:border-t tw:border-primary-100 tw:py-3 tw:text-success-800 tw:flex tw:items-center tw:justify-between"
                                >
                                <div class="tw:font-semibold">{{ 'SALE_DETAILS.tip' | translate }}</div>
                                <div class="tw:font-semibold">+{{ bookingSale()?.tip | merchantCurrency }}</div>
                              </div>
                            }
                          </div>
                        }
                        @if (store.salesModuleActive && bookingSale()?.missingPayment > 0) {
                          <div
                            class="tw:text-error-800 tw:flex tw:justify-between tw:border-t tw:border-primary-100 tw:py-3 tw:text-sm"
                            >
                            <div class="tw:font-semibold">{{ 'SALES_STATUS.pending' | translate }}</div>
                            <div class="tw:font-semibold">
                              {{ bookingSale()?.missingPayment | merchantCurrency }}
                            </div>
                          </div>
                        }
                        @if (!store.salesModuleActive && missingPaymentCents > 0) {
                          <div
                            class="tw:text-error-800 tw:flex tw:justify-between tw:border-t tw:border-primary-100 tw:py-3 tw:text-sm"
                            >
                            <div class="tw:font-semibold">{{ 'SALES_STATUS.pending' | translate }}</div>
                            <div class="tw:font-semibold">
                              {{ missingPaymentCents / 100 | merchantCurrency }}
                            </div>
                          </div>
                        }
                        <div class="tw:flex tw:justify-between tw:border-t tw:border-primary-100 tw:py-3 tw:text-sm tw:text-neutral-500">
                          <div class="tw:font-semibold">{{ 'GENERAL.total' | translate }}</div>
                          @if (totalPriceCents && totalPriceCents !== bookingSale()?.totalCents) {
                            @if (store.salesModuleActive) {
                              <div class="tw:flex tw:gap-2">
                                <div class="tw:line-through">{{ totalPriceCents / 100 | merchantCurrency }}</div>
                                <div class="tw:font-semibold">{{ bookingSale()?.total | merchantCurrency }}</div>
                              </div>
                            } @else {
                              <div class="tw:flex tw:gap-2">
                                <div class="tw:font-semibold">{{ totalPriceCents / 100 | merchantCurrency }}</div>
                              </div>
                            }
                          } @else {
                            <div class="tw:font-semibold">{{ bookingSale()?.total | merchantCurrency }}</div>
                          }
                        </div>
                        <!-- Sale area CTA's -->
                        @if (showPrePaymentLinkRow()) {
                          <div
                            class="tw:mt-3 tw:flex tw:flex-col tw:gap-3 tw:border-t tw:border-primary-100 tw:pt-3"
                            >
                            <button
                              type="button"
                              class="tw:flex tw:w-full tw:cursor-pointer tw:items-center tw:justify-center tw:gap-2 tw:border-0 tw:bg-transparent tw:p-0 tw:text-sm tw:leading-5 tw:text-neutral-500 hover:tw:opacity-80"
                              [attr.aria-expanded]="prePaymentLinkExpanded"
                              (click)="togglePrePaymentLinkExpanded()"
                              >
                              <span
                                aria-hidden="true"
                                >
                                <span class="material-icons tw:block tw:!text-[18px] tw:!leading-none">{{
                                  prePaymentLinkExpanded ? 'visibility_off' : 'visibility'
                                }}</span>
                              </span>
                              <span class="tw:leading-5">{{ 'SHARED.createBookingModal.prePaymentLink' | translate }}</span>
                            </button>
                            @if (prePaymentLinkExpanded) {
                              <app-clipboard-input [url]="getClientBookingPayUrl()" />
                            }
                          </div>
                        }
                        <div [class.tw:justify-between]="(bookingSale()?.code && canViewSaleDetails()) && (!isInvoicingActive() && canViewSaleDetails() && bookingSale()?.code && bookingSale()?.status !== ISaleStatus.CANCELLED)" [class.tw:justify-center]="!((bookingSale()?.code && canViewSaleDetails()) && (!isInvoicingActive() && canViewSaleDetails() && bookingSale()?.code && bookingSale()?.status !== ISaleStatus.CANCELLED))" class="tw:flex">
                          @if (bookingSale()?.code && canViewSaleDetails()) {
                            <app-button extraClass="tw:!px-0" size="sm" type="transparent" (clickEvent)="seeSaleDetails(bookingSale())">{{
                              'SHARED.createBookingModal.seeRegister' | translate
                            }}</app-button>
                          }
                          @if ((!isInvoicingActive() && canViewSaleDetails() && bookingSale()?.code && bookingSale()?.status !== ISaleStatus.CANCELLED) || bookingSale()?.status === ISaleStatus.DRAFT) {
                            <app-button extraClass="tw:!px-0" type="transparent" size="sm" (clickEvent)="editSale(bookingSale())">
                              {{ 'INVOICE_PREVIEW.editSale' | translate }}
                            </app-button>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
              <!-- REPEATING SERVICE BOX -->
              @if (!previewMode) {
                <ng-container formArrayName="services">
                  @for (box of servicesFormArray.controls; track box; let i = $index) {
                    <div class="service-box bg-light rd-2 mb-3" [formGroupName]="i">
                      <!-- Remove -->
                      @if (servicesFormArray.controls.length > 1) {
                        <i class="material-icons icon ico-remove" (click)="removeService(i)"
                          >cancel</i
                          >
                        }
                        <!-- PAST DATE WARNING -->
                        @if (checkPastTime(i)) {
                          <div class="row">
                            <div class="col">
                              <app-alert msg="{{ 'SHARED.createBookingModal.pastBookingWarning' | translate }}" type="warning" />
                            </div>
                          </div>
                        }
                        <!-- OUT OF SCHEDULLE WARNING -->
                        @if (checkOutOfBusinessHours(i)) {
                          <div class="row">
                            <div class="col">
                              <app-alert msg="{{ 'SHARED.createBookingModal.bookingOutOfBusinessHours' | translate }}"
                                type="warning"
                               />
                            </div>
                          </div>
                        }
                        <!-- CONFLICT WITH ANOTHER BOOKING WARNING -->
                        @if (box.get('availableWarning')?.value) {
                          <div class="row">
                            <div class="col">
                              <app-alert msg="{{ 'SHARED.createBookingModal.bookingConflictHours' | translate }}" type="danger" />
                            </div>
                          </div>
                        }
                        <!-- ROOM CONFLICT WITH ANOTHER BOOKING WARNING -->
                        @if (box.get('roomEquipmentAvailableWarning')?.value) {
                          <div class="row">
                            <div class="col">
                              <app-alert msg="{{ 'SHARED.createBookingModal.bookingRoomEquipmentConflictHours' | translate }}" type="danger" />
                            </div>
                          </div>
                        }
                        <!-- ROW - SERVICE TIME + SERVICE -->
                        <div class="form-row mb-3">
                          <div class="col-md-4 mb-3">
                            <div class="nomb form-row">
                              <div class="col">
                                <app-dropdown-input label="{{ 'SHARED.createBookingModal.hours' | translate }}"
                                  formControlName="startHour"
                                  [options]="availableHours"
                                  [submitAttempted]="submitAttempted"
                                  placeholder="{{ 'SHARED.createBookingModal.hour' | translate }}"
                                  invalidMsg="{{ 'SHARED.createBookingModal.hourInvalid' | translate }}"
                                 />
                              </div>
                              <div class="col">
                                <app-dropdown-input label="{{ 'SHARED.createBookingModal.minutes' | translate }}"
                                  formControlName="startMinutes"
                                  [options]="availableMinutes"
                                  [submitAttempted]="submitAttempted"
                                  placeholder="{{ 'SHARED.createBookingModal.minutes' | translate }}"
                                  invalidMsg="{{ 'SHARED.createBookingModal.hourInvalid' | translate }}"
                                 />
                              </div>
                            </div>
                            <!-- <div class="nomb"> -->
                            <!-- <app-dropdown-input
                            label="{{ 'SHARED.createBookingModal.hours' | translate }}"
                            formControlName="time"
                            [options]="times"
                            [submitAttempted]="submitAttempted"
                            placeholder="{{ 'SHARED.createBookingModal.hourPlaceholder' | translate }}"
                            invalidMsg="{{ 'SHARED.createBookingModal.hourInvalid' | translate }}"
                          ></app-dropdown-input> -->
                        <!-- </div> -->
                      </div>
                      <div class="col-md-8">
                        <div class="nomb">
                          <app-dropdown-input label="{{ 'SHARED.createBookingModal.service' | translate }}"
                            formControlName="service"
                            (change)="updateDurationFromService(i, box.get('provider')?.value, box.get('service')?.value); updateRoomEquipmentOptionsFromService(i, box.get('service')?.value)"
                            [options]="servicesFormArray.at(i)?.get('availableServices')?.value"
                            [submitAttempted]="submitAttempted"
                            placeholder="{{ 'SHARED.createBookingModal.selectServicePlaceholder' | translate }}"
                            invalidMsg="{{ 'SHARED.createBookingModal.selectServiceInvalid' | translate }}"
                            optionProperty="name"
                            optgroupProperty="{{ isSafariBefore17 ? null : 'category' }}"
                            optgroupPropertyValue="{{ isSafariBefore17 ? null : 'id' }}"
                           />
                        </div>
                      </div>
                    </div>
                    @if (servicesFormArray.at(i)?.get('availableRoomEquipments')?.value?.length > 0) {
                      <div class="form-row mb-3">
                        <div class="col-12">
                          <div class="nomb">
                            <app-dropdown-input-v2 label="{{ 'SHARED.createBookingModal.roomEquipment' | translate }}"
                              formControlName="roomEquipment"
                              [options]="servicesFormArray.at(i)?.get('availableRoomEquipments')?.value"
                              [submitAttempted]="submitAttempted"
                              placeholder="{{ 'SHARED.createBookingModal.selectRoomEquipmentPlaceholder' | translate }}"
                              [disableDefault]="false"
                              textOption="name"
                             />
                          </div>
                        </div>
                      </div>
                    }
                    <!-- ROW 2 - DURATION + PROVIDER -->
                    <div class="form-row mb-3">
                      <div class="col-4">
                        <div class="nomb">
                          <app-dropdown-input label="{{ 'SHARED.createBookingModal.duration' | translate }}"
                            formControlName="duration"
                            [options]="durationOptions"
                            [submitAttempted]="submitAttempted"
                            placeholder="{{ 'SHARED.createBookingModal.durationPlaceholder' | translate }}"
                            invalidMsg="{{ 'SHARED.createBookingModal.durationInvalid' | translate }}"
                           />
                        </div>
                      </div>
                      <div class="col-8">
                        <div class="nomb input-provider-wrap d-flex align-items-center">
                          <app-dropdown-input class="input-provider"
                            label="{{ 'SHARED.createBookingModal.providerLabel' | translate }}"
                            formControlName="provider"
                            (change)="updateDurationFromProvider(i, box.get('provider')?.value, box.get('service')?.value)"
                            [options]="providers"
                            optionProperty="name"
                            [submitAttempted]="submitAttempted"
                            placeholder="{{ 'SHARED.createBookingModal.providerPlaceholder' | translate }}"
                            invalidMsg="{{ 'SHARED.createBookingModal.providerInvalid' | translate }}"
                           />
                          <div
                            class="clickable"
                            (click)="toggleProviderSelected(i, servicesFormArray.at(i).get('providerSelected')?.value)"
                            [tooltip]="'DASHBOARD.calendarPage.providerSelected' | translate"
                            >
                            @if (servicesFormArray.at(i).get('providerSelected')?.value) {
                              <i
                                title="{{ 'DASHBOARD.calendarPage.providerSelected' | translate }}"
                                class="material-icons icon heart"
                                >favorite</i
                                >
                              }
                              @if (!servicesFormArray.at(i).get('providerSelected')?.value) {
                                <i
                                  title="{{ 'DASHBOARD.calendarPage.providerSelected' | translate }}"
                                  class="material-icons icon heart"
                                  >favorite_outline</i
                                  >
                                }
                              </div>
                            </div>
                          </div>
                        </div>
                        <div></div>
                      </div>
                    }
                  </ng-container>
                }
                @if (!previewMode) {
                  <div class="d-flex justify-content-end mt-3">
                    <div class="d-flex align-items-center">
                      <button type="button" class="btn btn-sm btn-secondary" (click)="addService()">
                        <i class="material-icons icon">add</i> {{ 'SHARED.createBookingModal.addService' | translate }}
                      </button>
                      @if (currentMerchant?.plan === 'free') {
                        <span class="upgrade" (click)="addService()">PRO</span>
                      }
                    </div>
                  </div>
                }
              </div>
              @if (previewMode) {
                <div class="col-lg-6">
                  <!-- ROW - CLIENT Preview -->
                  <div class="bg-light rd-2 client-preview mb-3 p-3">
                    <div class="row">
                      <div class="col">
                        <div class="d-flex align-items-center justify-content-between mb-3">
                          <div class="d-flex align-items-center">
                            <h3 class="mr-2 mb-0">{{ existingClient?.firstName + ' ' + existingClient?.lastName }}</h3>
                            @if (existingClient?.id) {
                              <i
                                class="material-icons ico tw:text-[20px]! tw:cursor-pointer text-secondary mb-0"
                                (click)="editClient()"
                                >edit</i
                                >
                              }
                            </div>
                            @if (event?.id && existingClient?.id) {
                              <app-client-loyalty-score [isLoyaltyPrizeBooking]="event?.isLoyaltyPrizeBooking"
                                [clientId]="existingClient?.id"
                                [clientName]="existingClient?.firstName + ' ' + existingClient?.lastName"
                                [bookingId]="event?.id"
                               />
                            }
                          </div>
                          @if (showContactDetails) {
                            <div class="d-flex justify-content-between align-items-center mb-3">
                              <div class="tw:max-w-60">
                                <div class="data-title">{{ 'SHARED.createBookingModal.phoneLabel' | translate }}</div>
                                <div class="data-value truncate">{{ existingClient?.phoneNumber || '-' }}</div>
                              </div>
                              @if (existingClient?.phoneNumber) {
                                <div class="d-flex align-items-center">
                                  <button
                                    type="button"
                                    class="btn btn-secondary copy-link tw:border-[#128c7e]! mr-2"
                                    (click)="openWhatsApp(existingClient?.phoneNumber)"
                                    >
                                    <i class="material-icons ico tw:text-[#128c7e]">chat_bubble</i>
                                  </button>
                                  <button
                                    type="button"
                                    class="btn btn-secondary copy-link"
                                    (click)="openPhone(existingClient?.phoneNumber)"
                                    >
                                    <i class="material-icons ico">phone</i>
                                  </button>
                                </div>
                              }
                            </div>
                          }
                          @if (showContactDetails) {
                            <div class="d-flex justify-content-between align-items-center mb-3">
                              <div class="tw:max-w-60">
                                <div class="data-title">{{ 'SHARED.createBookingModal.emailLabel' | translate }}</div>
                                <div class="data-value truncate">{{ existingClient?.email || '-' }}</div>
                              </div>
                              @if (existingClient?.email) {
                                <div class="d-flex align-items-center">
                                  <button
                                    type="button"
                                    class="btn btn-secondary copy-link mr-2"
                                    [cdkCopyToClipboard]="existingClient?.email"
                                    >
                                    <i class="material-icons ico">content_copy</i>
                                  </button>
                                  <button type="button" class="btn btn-secondary copy-link" (click)="openEmail(existingClient?.email)">
                                    <i class="material-icons ico">email</i>
                                  </button>
                                </div>
                              }
                            </div>
                          }
                          <div class="d-flex justify-content-between align-items-center mb-3">
                            <div>
                              <div class="data-title">{{ 'SHARED.createBookingModal.notesLabel' | translate }}</div>
                              <div class="data-value">{{ event?.notes || '-' }}</div>
                            </div>
                          </div>
                          @for (customField of merchantCustomFields; track customField; let i = $index) {
                            <div
                              class="d-flex justify-content-between align-items-center mb-3"
                              >
                              <div>
                                <div class="data-title">{{ merchantCustomFields[i].name }}</div>
                                <div class="data-value">{{ event?.client?.customFields?.[merchantCustomFields[i]?.id] || '-' }}</div>
                              </div>
                            </div>
                          }
                          <ng-container *ngTemplateOutlet="expandClient" />
                          @if (showAdvancedFields) {
                            <div class="mt-3">
                              <div class="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                  <div class="data-title">{{ 'SHARED.createBookingModal.vatNumberLabel' | translate }}</div>
                                  <div class="data-value">{{ existingClient?.vatNumber || '-' }}</div>
                                </div>
                              </div>
                              <div class="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                  <div class="data-title">{{ 'DASHBOARD.clientForm.dob' | translate }}</div>
                                  <div class="data-value">{{ existingClient?.dob || '-' }}</div>
                                </div>
                              </div>
                              <div class="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                  <div class="data-title">{{ 'DASHBOARD.clientForm.subscribed' | translate }}</div>
                                  <div class="data-value">
                                    {{ existingClient?.unsubscribed ? ('GENERAL.no' | translate) : ('GENERAL.yes' | translate) }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                } @else {
                  <!-- COLUMN 2 - CLIENT -->
                  <div class="col-lg-6">
                    <!-- ROW - CLIENT NAME -->
                    <div class="bg-light rd-2 mb-3 p-3">
                      <div class="row">
                        <div class="col">
                          <div class="d-flex align-items-center justify-content-between">
                            <h3 class="h3 mt-2 mr-2">{{ 'SHARED.createBookingModal.client' | translate }}</h3>
                            @if (event?.id && existingClient?.id) {
                              <app-client-loyalty-score [isLoyaltyPrizeBooking]="event?.isLoyaltyPrizeBooking"
                                [clientId]="existingClient?.id"
                                [clientName]="existingClient?.firstName + ' ' + existingClient?.lastName"
                                [bookingId]="event?.id"
                               />
                            }
                          </div>
                          @if (isBrowser) {
                            <div class="form-group position-relative autocomplete">
                              <label>{{ 'SHARED.createBookingModal.client' | translate }}</label>
                              <div class="input-wrap">
                                <input
                                  [ngClass]="{ 'is-invalid': submitAttempted && !form.get('client_name')?.valid }"
                                  formControlName="client_name"
                                  [typeahead]="searchClients"
                                  [typeaheadItemTemplate]="itemTemplate"
                                  [typeaheadMinLength]="3"
                                  [typeaheadWaitMs]="500"
                                  (typeaheadNoResults)="changeTypehead($event)"
                                  [typeaheadLatinize]="true"
                                  (typeaheadLoading)="typeaheadLoading = $event"
                                  [typeaheadOptionsLimit]="200"
                                  [typeaheadOptionsInScrollableView]="8"
                                  [typeaheadScrollable]="true"
                                  (typeaheadOnSelect)="typeaheadOnSelect($event)"
                                  typeaheadOptionField="fullName"
                                  name="clientsearch"
                                  type="text"
                                  class="form-control"
                                  id="client_name"
                                  placeholder="{{ 'SHARED.createBookingModal.clientPlaceholder' | translate }}"
                                  autocomplete="client-name"
                                  />
                                @if (typeaheadLoading) {
                                  <i class="loading-spinner rotating"></i>
                                }
                                @if (existingClient) {
                                  <i class="material-icons icon" (click)="editClient()">edit</i>
                                }
                                @if (submitAttempted && form.get('client_name')?.hasError('required')) {
                                  <div class="invalid-feedback">
                                    {{ 'SHARED.createBookingModal.clientInvalid' | translate }}
                                  </div>
                                }
                                @if (submitAttempted && form.get('client_name')?.hasError('maxlength')) {
                                  <div class="invalid-feedback">
                                    {{ 'SHARED.createBookingModal.clientNameMaxLength' | translate }}
                                  </div>
                                }
                              </div>
                              @if (showNewClientWarning()) {
                                <div class="tw:mt-2">
                                  <app-alert msg="{{ 'SHARED.createBookingModal.newClientWarning' | translate }}"
                                    type="warning"
                                   />
                                </div>
                              }
                              <ng-template #itemTemplate let-model="item" let-index="index">
                                <div class="d-flex align-items-center flex-md-row">
                                  <i class="material-icons mr-2 opacity-50">account_circle</i>
                                  <div class="item">
                                    <span class="title d-block">{{ model?.firstName }} {{ model?.lastName }}</span>
                                    @if (model?.email && model?.phoneNumber && showContactDetails) {
                                      <span class="desc truncate">
                                        {{ model?.phoneNumber }} • {{ model?.email }}
                                      </span>
                                    }
                                    @if (!model?.email && model?.phoneNumber && showContactDetails) {
                                      <span class="desc truncate">{{
                                        model?.phoneNumber
                                      }}</span>
                                    }
                                    @if (model?.email && !model?.phoneNumber && showContactDetails) {
                                      <span class="desc truncate">{{
                                        model?.email
                                      }}</span>
                                    }
                                  </div>
                                </div>
                              </ng-template>
                            </div>
                          }
                        </div>
                      </div>
                      <!-- ROW CLIENT PHONE -->
                      @if (showContactDetails || !this.existingClient) {
                        <div class="row">
                          <div class="col">
                            <div class="form-group">
                              <label>{{ 'SHARED.createBookingModal.phoneLabel' | translate }}</label>
                              <app-phone-input controlName="phoneNumber" [form]="form" [submitAttempted]="submitAttempted" />
                            </div>
                          </div>
                        </div>
                      }
                      <!-- ROW CLIENT EMAIL -->
                      @if (showContactDetails || !this.existingClient) {
                        <div class="row">
                          <div class="col">
                            <app-text-input label="{{ 'SHARED.createBookingModal.emailLabel' | translate }}"
                              formControlName="email"
                              [submitAttempted]="submitAttempted && !!form.get('email')?.enabled"
                              placeholder="{{ 'SHARED.createBookingModal.emailPlaceholder' | translate }}"
                              invalidMsg="{{ 'SHARED.createBookingModal.emailInvalid' | translate }}"
                              inputType="text"
                             />
                          </div>
                        </div>
                      }
                      <!-- ROW CLIENT NOTES -->
                      <div class="row">
                        <div class="col">
                          <div class="form-group">
                            <label for="">{{ 'SHARED.createBookingModal.notesLabel' | translate }}</label>
                            <textarea
                              cols="30"
                              rows="3"
                              class="form-control"
                              placeholder="{{ 'SHARED.createBookingModal.notesPlaceholder' | translate }}"
                              formControlName="notes"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                      <ng-container *ngTemplateOutlet="expandClient" />
                      @if (showAdvancedFields) {
                        <!-- ROW CLIENT VAT -->
                        @if (showContactDetails || !this.existingClient) {
                          <div class="row">
                            <div class="col">
                              <app-text-input label="{{ 'SHARED.createBookingModal.vatNumberLabel' | translate }}"
                                formControlName="vatNumber"
                                [submitAttempted]="submitAttempted && !!form.get('vatNumber')?.enabled"
                                            invalidMsg="{{
                                                'SHARED.paymentModal.vatNumberInvalid'
                                                    | translate: { value: intlService.getCurrentCountry()?.toUpperCase() }
                                            }}"
                                inputType="text"
                               />
                            </div>
                          </div>
                        }
                        <!-- ROW CLIENT DOB -->
                        <div class="row">
                          <div class="col">
                            <label>{{ 'DASHBOARD.clientForm.dob' | translate }}</label>
                            <input
                              type="text"
                              [class.is-invalid]="submitAttempted && form.get('dob')?.enabled && !form.get('dob')?.valid"
                              class="form-control mb-3"
                              bsDatepicker
                              formControlName="dob"
                              [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }"
                              />
                          </div>
                        </div>
                        <!-- ROW CLIENT Marketing permission -->
                        <div class="row">
                          <div class="col">
                            <div class="custom-control custom-checkbox">
                              <div class="custom-control custom-checkbox mb-3 pl-1">
                                <input formControlName="subscribed" type="checkbox" class="custom-control-input" id="subscribed" />
                                <label class="custom-control-label" for="subscribed">
                                  {{ 'DASHBOARD.clientForm.subscribed' | translate }}
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <!-- CUSTOM FIELDS -->
                        @if (form.get('customFields')) {
                          <ng-container formArrayName="customFields">
                            @for (customField of merchantCustomFields; track customField; let i = $index) {
                              <div class="row mb-2" [formGroupName]="i">
                                <div class="col">
                                  @if (customField.type === 'dropdown') {
                                    <app-dropdown-input
                                      [formControlName]="'_' + merchantCustomFields[i]?.id"
                                      [label]="merchantCustomFields[i].name"
                                      [placeholder]=""
                                      invalidMsg="{{ 'CLIENT.clientConfirm.requiredField' | translate }}"
                                      [options]="merchantCustomFields[i].dropdownValues"
                                      [submitAttempted]="submitAttempted"
                                      />
                                  }
                                  @if (customField.type === 'text') {
                                    <app-text-input
                                      [formControlName]="'_' + merchantCustomFields[i]?.id"
                                      [placeholder]=""
                                      [label]="merchantCustomFields[i].name"
                                      />
                                  }
                                  @if (customField.type === 'date' && customField.key !== 'dob') {
                                    <div class="form-group">
                                      <label>{{ customField.name }}</label>
                                      <input
                                        type="text"
                                        [class.is-invalid]="submitAttempted && !form.get('_' + merchantCustomFields[i]?.id)?.valid"
                                        class="form-control mb-3"
                                        bsDatepicker
                                        [formControlName]="'_' + merchantCustomFields[i]?.id"
                                        [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }"
                                        />
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                          </ng-container>
                        }
                      }
                    </div>
                    <!-- ROW CHECKBOXES -->
                    <div class="row">
                      <div class="col">
                        <div class="more-options">
                          @if (!event) {
                            <div class="custom-control custom-checkbox">
                              <input
                                formControlName="sendEmailCheck"
                                type="checkbox"
                                (change)="toggleSendEmail($event)"
                                class="custom-control-input"
                                id="sendEmailCheck"
                                />
                              <label class="custom-control-label" for="sendEmailCheck">
                                {{ 'SHARED.createBookingModal.notifyClient' | translate }}
                              </label>
                            </div>
                          }
                          @if (!event && form.get('sendEmailCheck')?.value && canShowSendPaymentLinkOption()) {
                            <div
                              class="custom-control custom-checkbox"
                              >
                              <input
                                formControlName="sendPaymentLinkCheck"
                                type="checkbox"
                                class="custom-control-input"
                                id="sendPaymentLinkCheck"
                                />
                              <label class="custom-control-label" for="sendPaymentLinkCheck">
                                {{ 'SHARED.createBookingModal.sendPaymentLink' | translate }}
                              </label>
                            </div>
                          }
                          @if (
                            !event &&
                            form.get('recurrentCheck')?.enabled &&
                            (['admin', 'manager'].includes((currentUserObservable | async)?.role) ||
                            ((currentUserObservable | async)?.role == 'provider' && !isFreePlan()))
                            ) {
                            <div
                              class="custom-control custom-checkbox"
                              >
                              <input
                                formControlName="recurrentCheck"
                                type="checkbox"
                                [checked]="false"
                                (change)="toggleRecurrent($event)"
                                class="custom-control-input"
                                id="recurrentCheck"
                                />
                              <label class="custom-control-label" for="recurrentCheck">
                                {{ 'SHARED.createBookingModal.repeatBooking' | translate }}
                                @if (currentMerchant?.plan === 'free') {
                                  <span class="upgrade">PRO</span>
                                }
                              </label>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                    @if (!event && isRecurrent) {
                      <div class="row mb-2">
                        <div class="col-md-6">
                          <div class="nomb">
                            <app-dropdown-input label="{{ 'SHARED.createBookingModal.frequency' | translate }}"
                              formControlName="recurrent"
                              [options]="recurrentOptions"
                              optionProperty="name"
                              [submitAttempted]="submitAttempted"
                             />
                          </div>
                        </div>
                        <div class="col-md-6">
                          @if (isRecurrent) {
                            <label>{{ 'SHARED.createBookingModal.until' | translate }}</label>
                          }
                          <!-- desktop -->
                          @if (isRecurrent) {
                            <input
                              class="form-control no-mobile"
                              formControlName="recurrentUntil"
                              [ngClass]="{ 'is-invalid': submitAttempted && form.get('recurrentUntil')?.invalid }"
                              bsDatepicker
                              placement="top"
                              [minDate]="minDate"
                              [bsConfig]="bsConfig"
                              />
                          }
                          <!-- mobile -->
                          @if (isRecurrent) {
                            <input
                              class="form-control just-mobile"
                              readonly="true"
                              [value]="form.get('recurrentUntil')?.value | date: 'dd/MM/yyyy'"
                              (click)="recurrentUntilPickerMobile = true"
                              [ngClass]="{ 'is-invalid': submitAttempted && form.get('recurrentUntil')?.invalid }"
                              />
                          }
                          @if (recurrentUntilPickerMobile) {
                            <app-mobile-date-picker title="{{ 'SHARED.createBookingModal.until' | translate }}"
                              [bsConfig]="bsConfig"
                              [minDate]="minDate"
                              [bsValue]="form.get('recurrentUntil')?.value"
                              (modalDismiss)="recurrentUntilPickerMobile = false"
                              (bsValueChange)="form.patchValue({ recurrentUntil: $event })"
                               />
                          }
                        </div>
                      </div>
                    }
                    <div class="row mt-2">
                      <div class="col">
                        <app-alert [msg]="errorMsg" type="danger" />
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
            <div class="fixed-bottom d-flex justify-content-center position-sticky tw:gap-2 bg-white p-3">
              @if (previewMode) {
                @if (canShowBookingEditAndSubmitActions()) {
                  <button
                    type="button"
                    class="btn btn-md"
                    [class.btn-primary]="!hasLegacyPosIntegration()"
                    [class.btn-secondary]="hasLegacyPosIntegration()"
                    (click)="previewMode = false"
                    >
                    {{ 'GENERAL.edit' | translate }}
                  </button>
                }
                @if (store?.salesModuleActive) {
                  <!-- BOTTOM sales CTA's -->
                  @if (canCreateSale()) {
                    @if (!bookingSale()?.code || bookingSale()?.status === ISaleStatus.CANCELLED) {
                      <!-- empty - new sale -->
                      <app-button type="secondary" size="sm" (clickEvent)="createSale(bookingSale())">
                        @if (isInvoicingActive()) {
                          {{ 'INVOICE_PAYMENT_METHOD.doInvoice' | translate }}
                        } @else {
                          {{ 'GENERAL.pay' | translate }}
                        }
                      </app-button>
                    } @else if (isInvoicingActive() && [InvoiceStatus.PARTIALLY_INVOICED, InvoiceStatus.UNINVOICED].includes(bookingSale()?.invoiceStatus)) {
                      <!-- has invoicing active and is uninvoiced ou partially invoiced - invoice methods -->
                      <app-button type="secondary" size="sm" (clickEvent)="addInvoice(bookingSale())">
                        {{ 'INVOICE_PAYMENT_METHOD.doInvoice' | translate }}
                      </app-button>
                    } @else if (bookingSale()?.status === ISaleStatus.PENDING_PAYMENT) {
                      <!--  is pending payment - pay -->
                      <app-button type="secondary" size="sm" (clickEvent)="addPayment(bookingSale())">
                        {{ 'GENERAL.pay' | translate }}
                      </app-button>
                    }
                  }
                } @else {
                  <!-- LEGACY POS INTEGRATION -->
                  @if (hasLegacyPosIntegration() && !event?.meta?.data?.invoiceId) {
                    <app-button type="primary" size="sm" (clickEvent)="createLegacyInvoice()">
                      {{ 'SHARED.createInvoiceModal.invoiceCta' | translate }}
                    </app-button>
                  }
                  @if (canShowBookingTeyaPayButton()) {
                    <!-- TEYA!! -->
                    <app-button type="secondary" size="sm" (clickEvent)="paywithTeya()">
                      {{ 'SHARED.createInvoiceModal.terminalPay' | translate }}
                    </app-button>
                  }
                }
                @if (!hasLegacyPosIntegration() && checkCanDeleteBooking()) {
                  <app-button type="secondary" size="sm" (clickEvent)="deleteBooking()">
                    {{ 'SHARED.createBookingModal.deleteBooking' | translate }}
                  </app-button>
                }
              } @else {
                @if (canShowBookingEditAndSubmitActions()) {
                  <app-submit-btn inputClasses="btn-md"
                    [loading]="saving"
                    [disabled]="readOnly"
                    [hasError]="errorMsg"
                    [btnCopy]="
                        event ? ('SHARED.createBookingModal.saveBooking' | translate) : ('SHARED.createBookingModal.createBooking' | translate)
                    "
                   />
                }
                <button type="button" class="btn btn-md btn-secondary" (click)="close()">
                  {{ 'GENERAL.cancel' | translate }}
                </button>
              }
              @if (event && !readOnly && hasDropdownOptions()) {
                <button dropdownToggle type="button" dropdown class="btn btn-md btn-secondary position-relative pr-3">
                  <span class="selector d-flex align-items-center">
                    <i class="material-icons icon">more_horiz</i>
                  </span>
                  <ul *dropdownMenu class="dropdown-menu more-menu">
                    @if (checkTodayOrPastDate()) {
                      <li>
                        <a class="dropdown-item" (click)="noShowBooking(!this.event.noshow)">
                          @if (!this.event.noshow) {
                            <span>{{ 'SHARED.createBookingModal.missedBooking' | translate }}</span>
                          }
                          @if (this.event.noshow) {
                            <span>{{ 'SHARED.createBookingModal.notMissedBooking' | translate }}</span>
                          }
                        </a>
                      </li>
                    }
                    @if (hasLegacyPosIntegration() && checkCanDeleteBooking()) {
                      <li>
                        <a class="dropdown-item text-danger" (click)="deleteBooking()">
                          {{ 'SHARED.createBookingModal.deleteBooking' | translate }}
                        </a>
                      </li>
                    }
                  </ul>
                </button>
              }
            </div>
          </form>
        }
      </div>
    }

    <ng-template #expandClient>
      <div class="d-flex justify-content-center">
        @if (!showAdvancedFields) {
          <button type="button" class="btn btn-sm btn-secondary" (click)="showAdvancedFields = !showAdvancedFields">
            <i class="material-icons icon mr-2">visibility</i>{{ 'SHARED.createBookingModal.moreFields' | translate }}
          </button>
        }
        @if (showAdvancedFields) {
          <button type="button" class="btn btn-sm btn-secondary" (click)="showAdvancedFields = !showAdvancedFields">
            <i class="material-icons icon mr-2">visibility_off</i>{{ 'SHARED.createBookingModal.lessFields' | translate }}
          </button>
        }
      </div>
    </ng-template>
